module.exports = __webpack_public_path__ + "fonts/7c721d9.otf";